import type { OnClickEvent } from '@/core/types/react-overrides';
import type { TravelFormAirportResult } from '@/features/travel-form/travel-form-data-v1/travel-form-data-v1-type';

import React from 'react';

import CheckBox from '@/core/components/check-box/check-box';
import KeyboardNavigationItemDesktop from '@/core/components/dropdown/keyboard-navigation-item-desktop';
import {
    useActiveKeyboardItemName,
    useActiveKeyboardNavigationContainerIdAtom,
} from '@/core/components/dropdown/use-keyboard-navigation-container-desktop';

export default function AirportItem({
    airport,
    isDefault,
    isSelected,
    onAirportClick,
}: {
    airport: TravelFormAirportResult;
    isDefault: boolean;
    isSelected: boolean;
    onAirportClick: (airport: TravelFormAirportResult, event: OnClickEvent, enableNextInputOverlay?: boolean) => void;
}) {
    const activeKeyboardItemName = useActiveKeyboardItemName();
    const activeKeyboardNavigationContainerId = useActiveKeyboardNavigationContainerIdAtom();
    const isHighlighted =
        activeKeyboardItemName === airport.name &&
        activeKeyboardNavigationContainerId === 'travel-form-airport-overlay-container';

    return (
        <KeyboardNavigationItemDesktop
            name={airport.name}
            onSelect={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => onAirportClick(airport, event, true)}
        >
            <div
                className={
                    'travelFormAirportItemDesktop flex items-center justify-between w-full relative cursor-pointer overflow-hidden'
                }
                data-qa-id={'qa-travel-form-airport-desktop'}
                onClick={(event) => onAirportClick(airport, event)}
            >
                <div
                    className={`flex gap-10 justify-between items-center w-full pl-20 pr-20 ${isHighlighted ? 'bg-foam' : ''}`}
                    // eslint-disable-next-line no-inline-styles/no-inline-styles
                    style={{ height: isDefault ? 75 : 62, minWidth: 324 }}
                >
                    <span className={'pr-5 text-16'}>
                        <span className={'pr-5 text-16'}>{airport.name}</span>
                        <span className={'travelFormAirportCode text-14 text-dusty-gray'}>{airport.code}</span>
                    </span>
                    <span className={'pr-20'}>
                        <CheckBox
                            isSelected={isSelected}
                            onClick={(event) => onAirportClick(airport, event)}
                        />
                    </span>
                </div>
            </div>
            <style jsx>{`
                .travelFormAirportItemDesktop:hover {
                    background-color: var(--color-foam);
                }
                .travelFormAirportCode::after {
                    content: ')';
                }
                .travelFormAirportCode::before {
                    content: '(';
                }
            `}</style>
        </KeyboardNavigationItemDesktop>
    );
}
